import React from 'react';
type SectionProps = {
  id?: string;
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  children: React.ReactNode;
  alt?: boolean;
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  children,
  alt = false
}: SectionProps) {
  return <section id={id} className={`w-full px-4 py-14 sm:px-6 sm:py-20 ${alt ? 'bg-ink-900' : 'bg-ink-950'}`} data-id="element-209" data-mp="3fyhsdk6wut37">
      <div className="mx-auto w-full max-w-5xl" data-id="element-210" data-mp="cfx0nos8gjwd">
        <header className="mx-auto mb-8 max-w-3xl text-center sm:mb-12" data-id="element-211" data-mp="cg6ph91jkl0h">
          {eyebrow ? <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-lime sm:text-xs" data-id="element-212" data-mp="he8a3yem8se2">
              {eyebrow}
            </p> : null}
          <h2 className="font-display text-2xl leading-[1.1] text-white sm:text-4xl" data-id="element-213" data-mp="7oezp0q7mjbe">{title}</h2>
          {intro ? <p className="mt-4 text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-214" data-mp="vdr3fl2rpz6b">{intro}</p> : null}
        </header>
        {children}
      </div>
    </section>;
}